import { httpClient, HttpMethod } from './http-client';

export const getStates = () => {
  return httpClient('/states', HttpMethod.Get, null);
};

export const getStateWithCountryData = (stateId: number) => {
  return httpClient(`/states/${stateId}/country`, HttpMethod.Get, null);
};

export const getZones = () => {
  return httpClient('/zones', HttpMethod.Get, null);
};

export const getSuburbsByPostcode = (postcode: string) => {
  return httpClient(`/suburbs/postcode/${postcode}`, HttpMethod.Get, null);
};